<template>
    <div class="radio-wrapper">
        <input type="radio" :id="row.rowId" class="radio-linked-ques" name="drone" :checked="data" @click="clickHandler"><label class="custom-linked-radio-style" :for="row.rowId"><span><span></span></span></label>
    </div>
</template>

<script>
/**
 * emit colClick, emit valueChange
 */
export default {
    name: "RadioCustom",
    props: ["data", "row"],
    methods: {
        clickHandler(event) {
            let newEvent = {
                event: event,
                type: "RadioBox",
            };
            this.$emit("click", newEvent);
            this.$emit("valueChange", newEvent);
        }
    }
};
</script>

<style lang="less" scoped>
.radio-wrapper {
    text-align: center;
    .radio-linked-ques {
      width: 13px;
      height: 13px;
      opacity: 0;
    }
    label {
        position: absolute;
        left: 13px;
        top: 37%;
        width: 13px;
        height: 13px;
        border-radius: 50%;
        border: 1px solid #999;
    }
    /* //选中后label样式 */
    input:checked+label {
        width: 13px;
        height: 13px;
        background-color: #2ec2ff;
        border: 1px solid #2ec2ff;
        &::after {
            position: absolute;
            content: "";
            width: 5px;
            height: 5px;
            top: 3px;
            left: 3px;
            border-radius: 50%;
            background-color: #fff;
            border: 1px solid #fff;
      }
    }
    /* //鼠标悬浮label样式 */
    input:hover+label {
        width: 13px;
        height: 13px;
        background-color: rgba(46,194,255,0.4);
        border: 1px solid rgba(46,194,255,0.4);
        &::after {
            position: absolute;
            content: "";
            width: 5px;
            height: 5px;
            top: 3px;
            left: 3px;
            border-radius: 50%;
            background-color: #fff;
            border: 1px solid #fff;
      }
    }
    .checkbox {
        left: 24px;
        display: inline-block;
        border-radius: 3px;
        width: 16px;
        height: 16px;
        vertical-align: -3px;
        background: url("@{zhijiStaticImagePath}class-spr.png") no-repeat -168px 0;
        &:hover {
            background-position: -145px 0;
        }
        &.on {
            background-position: -145px -24px;
        }
    }
}
</style>
